import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_mpb8yp79mh: FaireBrandEntity = {
  token: "b_mpb8yp79mh",
  type: "brand",
  name: "GEMPARA",
  avatarUrl:
    "https://cdn.faire.com/fastly/7bdef7f7511a839997ef89e27bcb65904de76099a6da3887ddcf3d742d5b7c2d.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/557d6096f346a807d7aaf8a7441babe7d21768962d31bcec6b450249b0d33779.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/7bdef7f7511a839997ef89e27bcb65904de76099a6da3887ddcf3d742d5b7c2d.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/557d6096f346a807d7aaf8a7441babe7d21768962d31bcec6b450249b0d33779.jpeg",
  location: "Lewes, DE, USA",
  minimumOrderDollars: 139,
  rating: 1,
  reviewCount: 2,
  isInsider: true,
  description:
    "GEMPARA Inc. is a U.S.-based fine jewelry brand specializing in handcrafted designs featuring precious and semi-precious natural gemstones, as well as lab-grown diamonds and moissanite jewelry. Our collections blend traditional Indian craftsmanship with refined, modern styling — perfect for today’s conscious luxury buyer.\n\nEach piece is thoughtfully crafted by skilled artisans using natural stones such as sapphire, ruby, emerald, morganite, aquamarine, tanzanite, garnet, alexandrite, moonstone, and tourmaline. Our lab-grown diamond and moissanite pieces offer brilliance with an ethical, sustainable edge.\n\nWe proudly serve retailers with:\n\n💰 Profitable wholesale pricing to drive growth and loyalty\n\n✨ Trend-forward and classic designs for curated collections\n\n📦 Low minimums and ready inventory for flexibility\n\n🎁 Luxury-ready packaging to elevate the unboxing experience\n\nAt GEMPARA, every piece tells a story — of natural beauty, meticulous craftsmanship, and global elegance. We proudly support boutiques and retailers across the U.S., U.K., and beyond.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:44.543Z",
    importedBy: "entity-db-cli",
  },
};
